<template>
  <div class="columns">
    <div class="column">
      <div class="box">
        <p>Sites: {{ site_count }}</p>
        <p>Scans: {{ scan_count }}</p>
        <p>Accounts: {{ account_count }}</p>
        <p>Users: {{ user_count }}</p>
        <p>Vulnerabilities: {{ vulnerability_count }}</p>
        <p>Operations: {{ operation_count }}</p>
      </div>
    </div>
    <div class="column">
      <div class="box">
        Look and feel and this page will be the last to get rounded off in this build.
      </div>
    </div>
  </div>
</template>

<script>
import { getPath } from '@/api/common'

export default {
  
  name: 'Dashboard',

  data: () => ({
    site_count: 0,
    scan_count: 0,
    account_count: 0,
    user_count: 0,
    vulnerability_count: 0,
    operation_count: 0,
  }),

  created() {
    getPath({
      path: 'api/super/dashboard'
    }, ({data}) => {
      this.site_count = data.site_count
      this.scan_count = data.scan_count
      this.account_count = data.account_count
      this.user_count = data.user_count
      this.vulnerability_count = data.vulnerability_count
      this.operation_count = data.operation_count
    })
  }

}
</script>
